// GET BUTTONS AND CARD
const selectBtn = document.querySelectorAll(".bundle-se_button");
const closeBtn = document.querySelectorAll(".bundle-card_head .icon-close");
const bundleCard = document.querySelectorAll(".bundle-pr_card");
const bundleCardMob = document.querySelectorAll(".bundle-pr_card-mobile");
const CardItem = document.querySelectorAll(".grid__item");
const ulDiv = document.querySelector("slider-component");
const liDiv = document.querySelectorAll(".slick-bundle-slider .grid__item");
function bundleCardfordevice(x) {
  if (x.matches) {
    let formData = {
      items: [],
    };
    const bundle_addtocartmob = document.querySelector(".bundle-add-to_cart");
    selectBtn.forEach((button) => {
      button.addEventListener("click", (e) => {
        const btnID = e.target.getAttribute("id");
        bundleCardMob.forEach((card) => {
          const cardID = card.getAttribute("id");
          if (btnID === cardID) {
            liDiv.forEach((li) => {
              const liId = li.getAttribute("id");
              const getNum = liId.match(/\d+$/);
              const idNum = btnID.match(/\d+$/);

              if (getNum.input === liId) {
                const alink = li.querySelector(".card__heading");
                alink.classList.remove("card__link");

                // ulDiv.appendChild(card);
                card.classList.add("pr_card-show");
                $("#" + btnID)
                  .parents(".grid__item")
                  .addClass("bundle__show");
              }
            });
          }
        });
        const changeTxt = button.querySelector("div button");
        changeTxt.innerText = "added to bundle";
        const classAdd = button.querySelector("div button");
        classAdd.classList.add("static-orange");
        $("body").addClass("bundle_card-active");
        const btnProductmobID = e.target.getAttribute("bundle-id");
        var bundleGroup = "bundle-group-" + Date.now();
        formData.items.push({
          id: `${btnProductmobID}`,
          quantity: "1",
          properties: {
            _bundle_product: true,
            _bundle_group: bundleGroup,
          },
        });

        //    if (formData.items.length > 0) {
        //     formData.items.push({
        //         id: `${btnProductmobID}`,
        //         quantity: "1",
        //         properties: {
        //             "_bundle_product": true,
        //           "_bundle_group":bundleGroup
        //         },
        //     });
        // } else {
        //     formData.items.push({
        //         id: `${btnProductmobID}`,
        //         quantity: "1",
        //     });
        // }

        if (formData.items.length > 0) {
          bundle_addtocartmob.removeAttribute("disabled", "");
        } else {
          bundle_addtocartmob.setAttribute("disabled", "");
        }
        const btnHandle = e.target.getAttribute("bundle-handle");
        if (btnHandle) {
          fetch(window.Shopify.routes.root + `products/${btnHandle}.js`)
            .then((response) => response.json())
            .then((product) => {
              let newPrice = product.price;
              let setTotal = document.querySelector(".bundle-total");
              let setTotaldis = document.querySelector(".bundle-discounted");
              let discountVal = parseFloat(
                setTotaldis.getAttribute("discount-value")
              );
              // let country_count = setTotal.getAttribute('data-money');
              let currentTotal = parseFloat(setTotal.getAttribute("total"));
              currentTotal = setTotal.setAttribute(
                "total",
                `${newPrice + currentTotal}`
              );
              let getAgain = parseFloat(setTotal.getAttribute("total"));
              setTotal.innerHTML = `<span class="title">Price: </span><span class="total-price">${Shopify.formatMoney(
                getAgain
              )}</span>`;
              let getT1 = getAgain;
              let saved = (getT1 * discountVal) / 100;
              let disPrice = getT1 - saved;
              disPrice + getT1;
              // console.log(getT1, saved, disPrice)
              setTotaldis.innerHTML = `<span class="title">Price: </span><span class="discount-price">${Shopify.formatMoney(
                disPrice
              )}</span> <span class="total-price">${Shopify.formatMoney(
                getT1
              )}</span>`;
              if (formData.items.length > 1) {
                setTotal.classList.add("hidden");
                setTotaldis.classList.remove("hidden");
              } else {
                setTotal.classList.remove("hidden");
                setTotaldis.classList.add("hidden");
              }
            });
        }
      });
    });
    closeBtn.forEach((button) => {
      button.addEventListener("click", (e) => {
        const cbtnID = e.target.getAttribute("id");
        bundleCardMob.forEach((card) => {
          console.log("id::", e, card);
          const cardID = card.getAttribute("id");
          if (cbtnID === cardID) {
            liDiv.forEach((li) => {
              const liId = li.getAttribute("id");
              const getNum = liId.match(/\d+$/);
              const idNum = cbtnID.match(/\d+$/);
              if (getNum.input === liId) {
                const alink = li.querySelector(".card__heading");
                alink.classList.add("card__link");
                // ulDiv.removeChild(card);
                // li.appendChild(card);

                card.classList.remove("pr_card-show");
                $("#" + cbtnID)
                  .parents(".grid__item")
                  .removeClass("bundle__show");
              }
            });
          }
        });
        selectBtn.forEach((btn) => {
          const btnID = btn.querySelector("div button");
          let bid = btnID.getAttribute("id");
          if (cbtnID === bid) {
            const changeTxt = btn.querySelector("div button");
            changeTxt.innerText = "select";
            btnID.classList.remove("static-orange");
          }
        });
        $("body").removeClass("bundle_card-active");
        const btnProductIDmob = e.currentTarget.getAttribute("bundle-id");
        const indexToRemove = formData.items.findIndex(
          (item) => item.id === btnProductIDmob
        );
        if (indexToRemove !== -1) {
          formData.items.splice(indexToRemove, 1);
        }
        if (formData.items.length > 0) {
          bundle_addtocartmob.removeAttribute("disabled", "");
        } else {
          bundle_addtocartmob.setAttribute("disabled", "");
        }
        const btnHandle = e.currentTarget.getAttribute("bundle-handle");
        if (btnHandle) {
          fetch(window.Shopify.routes.root + `products/${btnHandle}.js`)
            .then((response) => response.json())
            .then((product) => {
              let setTotaldis = document.querySelector(".bundle-discounted");
              let newPrice = product.price;
              let setTotal = document.querySelector(".bundle-total");
              // let country_count = setTotal.getAttribute('data-money');
              let currentTotal = parseFloat(setTotal.getAttribute("total"));
              let discountVal = parseFloat(
                setTotaldis.getAttribute("discount-value")
              );
              if (currentTotal > newPrice) {
                currentTotal = setTotal.setAttribute(
                  "total",
                  `${currentTotal - newPrice}`
                );
                let getAgain = parseFloat(setTotal.getAttribute("total"));
                let this1 = getAgain;
                setTotal.innerHTML = `<span class="title">Price: </span><span class="total-price">${Shopify.formatMoney(
                  this1
                )}</span>`;
                let getT1 = getAgain;
                let saved = (getT1 * discountVal) / 100;
                let disPrice = getT1 - saved;
                disPrice - getT1;
                setTotaldis.innerHTML = `<span class="title">Price: </span><span class="discount-price">${Shopify.formatMoney(
                  disPrice
                )}</span> <span class="total-price">${Shopify.formatMoney(
                  getT1
                )}</span>`;
              } else {
                currentTotal = setTotal.setAttribute(
                  "total",
                  `${newPrice - currentTotal}`
                );
                let getAgain = parseFloat(setTotal.getAttribute("total"));
                let this1 = getAgain;
                setTotal.innerHTML = `<span class="title">Price: </span><span class="total-price">${Shopify.formatMoney(
                  this1
                )}</span>`;
                let getT1 = getAgain;
                let saved = (getT1 * discountVal) / 100;
                let disPrice = getT1 - saved;
                disPrice - getT1;
                setTotaldis.innerHTML = `<span class="title">Price: </span><span class="discount-price">${Shopify.formatMoney(
                  disPrice
                )}</span> <span class="total-price">${Shopify.formatMoney(
                  getT1
                )}</span>`;
              }
              if (formData.items.length == 1) {
                setTotal.classList.remove("hidden");
                setTotaldis.classList.add("hidden");
              } else if (formData.items.length < 1) {
                setTotal.classList.add("hidden");
                setTotaldis.classList.add("hidden");
              } else {
                setTotal.classList.add("hidden");
                setTotaldis.classList.remove("hidden");
              }
            });
        }
      });
    });
    bundle_addtocartmob.addEventListener("click", (e) => {
      const loadingSpinner = e.target.querySelector(".loading__spinner");
      if (loadingSpinner) {
        loadingSpinner.classList.remove("hidden");
      }

      if (bundle_addtocartmob) {
        for (let i = 0; i < bundle_addtocartmob.childNodes.length; ++i) {
          if (bundle_addtocartmob.childNodes[i].nodeType === Node.TEXT_NODE) {
            bundle_addtocartmob.removeChild(bundle_addtocartmob.childNodes[i]);
          }
        }
      }
      const uniqueId = "bundle-group-" + Date.now();
      if (formData.items.length >= 2) {
        formData.items.forEach((item) => {
          item.properties._bundle_id = uniqueId;
        });
      } else {
        formData.items.forEach((item) => {
          item.properties = null;
        });
      }
      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((response) => {
          fetch(`${routes.cart_url}?section_id=cart-drawer`)
            .then((response) => response.text())
            .then((responseText) => {
              const html = new DOMParser().parseFromString(
                responseText,
                "text/html"
              );
              const selectors = ["cart-drawer-items", ".cart-drawer__footer"];
              for (const selector of selectors) {
                const targetElement = document.querySelector(selector);
                const sourceElement = html.querySelector(selector);
                if (targetElement && sourceElement) {
                  targetElement.replaceWith(sourceElement);
                }
              }
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              const cartREmove = document.querySelector("cart-drawer");
              const removeInner = document.querySelector(
                ".drawer__inner-empty"
              );
              const removeAttr = document.querySelector(
                ".cart__checkout-button"
              );
              cartREmove.classList.remove("is-empty");
              removeAttr.removeAttribute("disabled");
              if (removeInner) {
                removeInner.remove();
              }
              if (loadingSpinner) {
                loadingSpinner.classList.add("hidden");
              }

              if (bundle_addtocartmob) {
                bundle_addtocartmob.insertAdjacentText(
                  "beforeend",
                  "ADD TO CART"
                );
              }
              cartREmove.classList.add("active");
                 function handleCloseButtonClickm(button) {
            const cbtnID = button.getAttribute("id");

            // Handle visibility of bundle cards
            bundleCardMob.forEach((card) => {
              const cardID = card.getAttribute("id");
              if (cbtnID === cardID) {
                card.classList.remove("pr_card-show");
                $("#" + cbtnID)
                  .parents(".grid__item")
                  .removeClass("bundle__show");

                const aLink = document
                  .querySelector(`#${cbtnID}`)
                  .closest(".grid__item");
                const anchor = aLink?.querySelector(".card__heading");
                if (anchor) {
                  anchor.classList.add("card__link");
                }
              }
            });

            // Update the select button text and styles
            selectBtn.forEach((btn) => {
              const btnID = btn.querySelector("div button");
              if (btnID) {
                const bid = btnID.getAttribute("id");
                if (cbtnID === bid) {
                  btnID.innerText = "select";
                  btnID.classList.remove("static-orange");
                }
              }
            });

            // Remove active class from body
            document.body.classList.remove("bundle_card-active");

            // Remove the item from formData
            const btnProductID = button.getAttribute("bundle-id");
            const indexToRemove = formData.items.findIndex(
              (item) => item.id === btnProductID
            );
            if (indexToRemove !== -1) {
              formData.items.splice(indexToRemove, 1);
            }

            // Toggle Add to Cart button
            if (formData.items.length > 0) {
              bundle_addtocartmob.removeAttribute("disabled");
            } else {
              bundle_addtocartmob.setAttribute("disabled", "");
            }

            // Reset total values
            const setTotaldis = document.querySelector(".bundle-discounted");
            const setTotal = document.querySelector(".bundle-total");

            if (setTotal && setTotaldis) {
              // Reset attributes and displayed values to 0
              let discountVal = parseFloat(
                setTotaldis.getAttribute("discount-value")
              );
              setTotal.setAttribute("total", "0");
              setTotaldis.setAttribute("discount-value", discountVal);

              setTotal.innerHTML = `<span class="title">Price: </span><span class="total-price">${Shopify.formatMoney(
                0
              )}</span>`;
              setTotaldis.innerHTML = `<span class="title">Price: </span><span class="discount-price">${Shopify.formatMoney(
                0
              )}</span> <span class="total-price">${Shopify.formatMoney(
                0
              )}</span>`;
            }
            setTotaldis.classList.add("hidden");
                     setTotal.classList.add("hidden");
          }
          // Attach the event listener to each button
          closeBtn.forEach((button) => {
            handleCloseButtonClickm(button);
          });
            });
          var cartContents = fetch(window.Shopify.routes.root + "cart.js")
            .then((response) => response.json())
            .then((data) => {
              const updateBubble = document.querySelector(
                ".cart-count-bubble span"
              );
              if (updateBubble) {
                updateBubble.innerHTML = data.item_count;
              } else {
                const cartLink = document.querySelector("#cart-icon-bubble");
                cartLink.insertAdjacentHTML(
                  "beforeend",
                  `<span class="visually-hidden">Cart</span><div class="cart-count-bubble"><span aria-hidden="true">${data.item_count}</span><span class="visually-hidden">${data.item_count} items</span></div>`
                );
              }

              if (data.item_count == 0) {
                document
                  .querySelector("cart-drawer.drawer")
                  .classList.add("is-empty");
              }
              // To trigger the Event
              document.dispatchEvent(custom_addToCart);
            });
          cartContents;
          return response.json();
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    });
  } else {
    let formData = {
      items: [],
    };
    const bundle_addtocart = document.querySelector(".bundle-add-to_cart");
    selectBtn.forEach((button) => {
      button.addEventListener("click", (e) => {
        const btnID = e.target.getAttribute("id");
        bundleCard.forEach((card) => {
          const cardID = card.getAttribute("id");
          if (btnID === cardID) {
            card.classList.add("pr_card-show");
            $("#" + btnID)
              .parents(".grid__item")
              .addClass("bundle__show");
            const aLink = document
              .querySelector("#" + btnID)
              .closest(".grid__item");
            const anchor = aLink.querySelector(".card__heading");
            if (anchor) {
              anchor.classList.remove("card__link");
            }
          }
        });

        const changeTxt = button.querySelector("div button");
        changeTxt.innerText = "added to bundle";
        const classAdd = button.querySelector("div button");
        classAdd.classList.add("static-orange");

        $("body").addClass("bundle_card-active");
        const btnProductID = e.target.getAttribute("bundle-id");
        // var bundleGroup = "bundle-group-" + Date.now();
        const uniqueId = "bundle-group-" + Date.now();
        formData.items.push({
          id: `${btnProductID}`,
          quantity: "1",
          properties: {
            _bundle_product: true,
          },
        });
        //    if (formData.items.length >= 0) {
        //     formData.items.push({
        //         id: `${btnProductID}`,
        //         quantity: "1",
        //         properties: {
        //             "_bundle_product": true,
        //         },
        //     });
        // } else {
        //     formData.items.push({
        //         id: `${btnProductID}`,
        //         quantity: "1",
        //     });
        // }

        if (formData.items.length > 0) {
          bundle_addtocart.removeAttribute("disabled", "");
        } else {
          bundle_addtocart.setAttribute("disabled", "");
        }
        const btnHandle = e.target.getAttribute("bundle-handle");
        if (btnHandle) {
          fetch(window.Shopify.routes.root + `products/${btnHandle}.js`)
            .then((response) => response.json())
            .then((product) => {
              let newPrice = product.price;
              let setTotal = document.querySelector(".bundle-total");
              let setTotaldis = document.querySelector(".bundle-discounted");
              let discountVal = parseFloat(
                setTotaldis.getAttribute("discount-value")
              );
              // let country_count = setTotal.getAttribute('data-money');
              let currentTotal = parseFloat(setTotal.getAttribute("total"));
              currentTotal = setTotal.setAttribute(
                "total",
                `${newPrice + currentTotal}`
              );

              let getAgain = parseFloat(setTotal.getAttribute("total"));

              setTotal.innerHTML = `<span class="title">Price: </span><span class="total-price">${Shopify.formatMoney(
                getAgain
              )}</span>`;
              let getT1 = getAgain;
              let saved = (getT1 * discountVal) / 100;
              let disPrice = getT1 - saved;
              disPrice + getT1;
              // console.log(getT1, saved, disPrice)
              setTotaldis.innerHTML = `<span class="title">Price: </span><span class="discount-price">${Shopify.formatMoney(
                disPrice
              )}</span> <span class="total-price">${Shopify.formatMoney(
                getT1
              )}</span>`;
              if (formData.items.length > 1) {
                setTotal.classList.add("hidden");
                setTotaldis.classList.remove("hidden");
              } else {
                setTotal.classList.remove("hidden");
                setTotaldis.classList.add("hidden");
              }
            });
        }
      });
    });

    closeBtn.forEach((button) => {
      button.addEventListener("click", (e) => {
        // console.log("e::2",e)
        const cbtnID = e.target.getAttribute("id");

        bundleCard.forEach((card) => {
          const cardID = card.getAttribute("id");
          if (cbtnID === cardID) {
            card.classList.remove("pr_card-show");
            $("#" + cbtnID)
              .parents(".grid__item")
              .removeClass("bundle__show");
            const aLink = document
              .querySelector("#" + cbtnID)
              .closest(".grid__item");
            const anchor = aLink.querySelector(".card__heading");
            if (anchor) {
              anchor.classList.add("card__link");
            }
          }
        });

        selectBtn.forEach((btn) => {
          const btnID = btn.querySelector("div button");
          let bid = btnID.getAttribute("id");
          if (cbtnID === bid) {
            const changeTxt = btn.querySelector("div button");
            changeTxt.innerText = "select";
            console.log("yes");
            btnID.classList.remove("static-orange");
          }
        });
        $("body").removeClass("bundle_card-active");
        const btnProductID = e.currentTarget.getAttribute("bundle-id");
        const indexToRemove = formData.items.findIndex(
          (item) => item.id === btnProductID
        );
        if (indexToRemove !== -1) {
          formData.items.splice(indexToRemove, 1);
        }
        if (formData.items.length > 0) {
          bundle_addtocart.removeAttribute("disabled", "");
        } else {
          bundle_addtocart.setAttribute("disabled", "");
        }
        const btnHandle = e.currentTarget.getAttribute("bundle-handle");
        if (btnHandle) {
          console.log(btnHandle);
          fetch(window.Shopify.routes.root + `products/${btnHandle}.js`)
            .then((response) => response.json())
            .then((product) => {
              let setTotaldis = document.querySelector(".bundle-discounted");
              let newPrice = product.price;
              let setTotal = document.querySelector(".bundle-total");
              // let country_count = setTotal.getAttribute('data-money');
              let currentTotal = parseFloat(setTotal.getAttribute("total"));
              let discountVal = parseFloat(
                setTotaldis.getAttribute("discount-value")
              );
              if (currentTotal > newPrice) {
                currentTotal = setTotal.setAttribute(
                  "total",
                  `${currentTotal - newPrice}`
                );
                let getAgain = parseFloat(setTotal.getAttribute("total"));
                let this1 = getAgain;
                setTotal.innerHTML = `<span class="title">Price: </span><span class="total-price">${Shopify.formatMoney(
                  this1
                )}</span>`;
                let getT1 = getAgain;
                let saved = (getT1 * discountVal) / 100;
                let disPrice = getT1 - saved;
                disPrice - getT1;
                setTotaldis.innerHTML = `<span class="title">Price: </span><span class="discount-price">${Shopify.formatMoney(
                  disPrice
                )}</span> <span class="total-price">${Shopify.formatMoney(
                  getT1
                )}</span>`;
              } else {
                currentTotal = setTotal.setAttribute(
                  "total",
                  `${newPrice - currentTotal}`
                );
                let getAgain = parseFloat(setTotal.getAttribute("total"));
                let this1 = getAgain;
                setTotal.innerHTML = `<span class="title">Price: </span><span class="total-price">${Shopify.formatMoney(
                  this1
                )}</span>`;
                let getT1 = getAgain;
                let saved = (getT1 * discountVal) / 100;
                let disPrice = getT1 - saved;
                disPrice - getT1;
                setTotaldis.innerHTML = `<span class="title">Price: </span><span class="discount-price">${Shopify.formatMoney(
                  disPrice
                )}</span> <span class="total-price">${Shopify.formatMoney(
                  getT1
                )}</span>`;
              }
              if (formData.items.length == 1) {
                setTotal.classList.remove("hidden");
                setTotaldis.classList.add("hidden");
              } else if (formData.items.length < 1) {
                setTotal.classList.add("hidden");
                setTotaldis.classList.add("hidden");
              } else {
                setTotal.classList.add("hidden");
                setTotaldis.classList.remove("hidden");
              }
            });
        }
      });
    });

    bundle_addtocart.addEventListener("click", (e) => {
      const loadingSpinner = e.target.querySelector(".loading__spinner");
      if (loadingSpinner) {
        loadingSpinner.classList.remove("hidden");
      }

      if (bundle_addtocart) {
        for (let i = 0; i < bundle_addtocart.childNodes.length; ++i) {
          if (bundle_addtocart.childNodes[i].nodeType === Node.TEXT_NODE) {
            bundle_addtocart.removeChild(bundle_addtocart.childNodes[i]);
          }
        }
      }
      const uniqueId = "bundle-group-" + Date.now();
      if (formData.items.length >= 2) {
        formData.items.forEach((item) => {
          item.properties._bundle_id = uniqueId;
        });
      } else {
        formData.items.forEach((item) => {
          item.properties = null;
        });
      }

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((response) => {
          fetch(`${routes.cart_url}?section_id=cart-drawer`)
            .then((response) => response.text())
            .then((responseText) => {
              const html = new DOMParser().parseFromString(
                responseText,
                "text/html"
              );
              const selectors = ["cart-drawer-items", ".cart-drawer__footer"];
              for (const selector of selectors) {
                const targetElement = document.querySelector(selector);
                const sourceElement = html.querySelector(selector);
                if (targetElement && sourceElement) {
                  targetElement.replaceWith(sourceElement);
                }
              }
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              const cartREmove = document.querySelector("cart-drawer");
              const removeInner = document.querySelector(
                ".drawer__inner-empty"
              );
              const removeAttr = document.querySelector(
                ".cart__checkout-button"
              );
              cartREmove.classList.remove("is-empty");
              removeAttr.removeAttribute("disabled");
              if (removeInner) {
                removeInner.remove();
              }
              if (loadingSpinner) {
                loadingSpinner.classList.add("hidden");
              }

              if (bundle_addtocart) {
                bundle_addtocart.insertAdjacentText(
                  "beforeend",
                  "Add bundle to cart"
                );
              }
              cartREmove.classList.add("active");
            });
          var cartContents = fetch(window.Shopify.routes.root + "cart.js")
            .then((response) => response.json())
            .then((data) => {
              const updateBubble = document.querySelector(
                ".cart-count-bubble span"
              );
              if (updateBubble) {
                updateBubble.innerHTML = data.item_count;
              } else {
                const cartLink = document.querySelector("#cart-icon-bubble");
                cartLink.insertAdjacentHTML(
                  "beforeend",
                  `<span class="visually-hidden">Cart</span><div class="cart-count-bubble"><span aria-hidden="true">${data.item_count}</span><span class="visually-hidden">${data.item_count} items</span></div>`
                );
              }

              if (data.item_count == 0) {
                document
                  .querySelector("cart-drawer.drawer")
                  .classList.add("is-empty");
              }
              // To trigger the Event
              document.dispatchEvent(custom_addToCart);
            });
          cartContents;
          function handleCloseButtonClick(button) {
            const cbtnID = button.getAttribute("id");

            // Handle visibility of bundle cards
            bundleCard.forEach((card) => {
              const cardID = card.getAttribute("id");
              if (cbtnID === cardID) {
                card.classList.remove("pr_card-show");
                $("#" + cbtnID)
                  .parents(".grid__item")
                  .removeClass("bundle__show");

                const aLink = document
                  .querySelector(`#${cbtnID}`)
                  .closest(".grid__item");
                const anchor = aLink?.querySelector(".card__heading");
                if (anchor) {
                  anchor.classList.add("card__link");
                }
              }
            });

            // Update the select button text and styles
            selectBtn.forEach((btn) => {
              const btnID = btn.querySelector("div button");
              if (btnID) {
                const bid = btnID.getAttribute("id");
                if (cbtnID === bid) {
                  btnID.innerText = "select";
                  btnID.classList.remove("static-orange");
                }
              }
            });

            // Remove active class from body
            document.body.classList.remove("bundle_card-active");

            // Remove the item from formData
            const btnProductID = button.getAttribute("bundle-id");
            const indexToRemove = formData.items.findIndex(
              (item) => item.id === btnProductID
            );
            if (indexToRemove !== -1) {
              formData.items.splice(indexToRemove, 1);
            }

            // Toggle Add to Cart button
            if (formData.items.length > 0) {
              bundle_addtocart.removeAttribute("disabled");
            } else {
              bundle_addtocart.setAttribute("disabled", "");
            }

            // Reset total values
            const setTotaldis = document.querySelector(".bundle-discounted");
            const setTotal = document.querySelector(".bundle-total");

            if (setTotal && setTotaldis) {
              // Reset attributes and displayed values to 0
              let discountVal = parseFloat(
                setTotaldis.getAttribute("discount-value")
              );
              setTotal.setAttribute("total", "0");
              setTotaldis.setAttribute("discount-value", discountVal);

              setTotal.innerHTML = `<span class="title">Price: </span><span class="total-price">${Shopify.formatMoney(
                0
              )}</span>`;
              setTotaldis.innerHTML = `<span class="title">Price: </span><span class="discount-price">${Shopify.formatMoney(
                0
              )}</span> <span class="total-price">${Shopify.formatMoney(
                0
              )}</span>`;
            }
            setTotaldis.classList.add("hidden");
             setTotal.classList.add("hidden");
          }
          // Attach the event listener to each button
          closeBtn.forEach((button) => {
            handleCloseButtonClick(button);
          });

          return response.json();
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    });
  }
}

var x = window.matchMedia("(max-width: 768px)");

bundleCardfordevice(x);

x.addEventListener("change", function () {
  bundleCardfordevice(x);
});

// BUNDLE PRODUCT DISCOUNT

// const newLocal = subscribe(PUB_SUB_EVENTS.cartUpdate, async (event) => {
// 	const discountCodeElement = document.querySelector(".discount_code1");
// 	const discountCode = discountCodeElement
// 		? encodeURIComponent(discountCodeElement.value)
// 		: "";
// 	if (window.location.href.includes("products") && discountCode) {
// 		const url = window.location.pathname;
// 		const result = url.replace(/^\/products\//, "");
// 		try {
// 			// Fetch cart details
// 			const response = await fetch("/cart.js");
// 			const cart = await response.json();

// 			let discountApplied = false;

// 			for (const item of cart.items) {
// 				if (
// 					item.quantity === 1 &&
// 					item.properties &&
// 					item.properties._type === "Buy 2 to get 10%"
// 				) {
// 					if (
// 						item.handle === result &&
// 						item.properties &&
// 						item.properties._type === "Buy 2 to get 10%"
// 					) {
// 						discountApplied = true;
// 						if (discountCode) {
// 							// Set the discount code in the cookie
// 							document.cookie = `discount_code=${discountCode}; path=/`;

// 							const getcartElem = document.querySelector(
// 								"cart-drawer-items form"
// 							);
// 							getcartElem.setAttribute(
// 								"action",
// 								`/cart?discount=${discountCode}`
// 							);
// 						}
// 					}
// 				} else {
// 					document.cookie = `discount_code=; path=/`;

// 					const getcartElem = document.querySelector("cart-drawer-items form");
// 					getcartElem.setAttribute("action", "/cart?discount=''");
// 				}
// 			}

// 			if (!discountApplied && discountCode) {
// 				// // Remove the discount code from the cookie
// 				document.cookie = `discount_code=; path=/`;

// 				const getcartElem = document.querySelector("cart-drawer-items form");
// 				getcartElem.setAttribute("action", "/cart?discount=''");
// 			}
// 		} catch (error) {
// 			console.error("Error:", error);
// 		}
// 	}
// });

// newLocal;
